import React from "react";
import TeamManagerContainer from "../../TeamManager/containers/TeamManagerContainer";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";

const SettingsTeamDetails = ({ settingsPath, lastEditedAt, changelogVersions }) => (
  <SettingsPageWrapper settingsPath={settingsPath} title="Team" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
    <TeamManagerContainer />
  </SettingsPageWrapper>
);

export default SettingsTeamDetails;
